// extracted by mini-css-extract-plugin
export default {"role":"B+3Il"};